import {
	DEFAULT_SHORTCUT_LABEL,
	MAC_PLATFORM_PATTERN,
	MAC_SHORTCUT_LABEL,
} from '../constants/pageSearch.constants';

export const getShortcutLabel = () =>
	MAC_PLATFORM_PATTERN.test(navigator.userAgent)
		? MAC_SHORTCUT_LABEL
		: DEFAULT_SHORTCUT_LABEL;
